module.exports = __webpack_public_path__ + "media/images/icons/favorites_black-5e1803994d0121d82fffed0ab73f41d1.svg";